var _g, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59.182mm",
    height: "12.09mm",
    viewBox: "0 0 59.182 12.09",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.258 -33.087)",
    strokeWidth: 0.26458
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.8101 -21.78)",
    fill: "#fff",
    "aria-label": "Runner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.448 66.72 1.6425-11.684q1.6256-0.16933 4.5381-0.16933 2.3876 0 3.4544 0.82973 1.0837 0.82973 0.8128 2.8109-0.1524 1.1853-0.74507 1.8796-0.59266 0.69426-1.8796 0.82973l-0.01693 0.11853q1.2869 0.22013 1.4732 1.8288l0.508 3.556h-3.2681l-0.4064-3.5729q-0.03387-0.508-0.2032-0.6604-0.16933-0.16933-0.6096-0.16933h-1.5748l-0.62653 4.4027zm4.0471-6.7225h1.524q0.8636 0 1.2192-0.3048 0.3556-0.3048 0.49107-1.2192 0.1016-0.74506-0.1524-1.016-0.23707-0.27093-0.99906-0.27093l-1.6933 0.01693z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.039 58.304-1.1684 8.4158h-2.4045l-0.01693-1.5071q-1.8119 1.7441-3.5391 1.7441-1.2531 0-1.8457-0.62653-0.57573-0.64346-0.4064-1.778l0.8636-6.2484h3.0988l-0.77893 5.3848q-0.0508 0.37253 0.06773 0.52493 0.13547 0.1524 0.42333 0.1524 0.762 0 1.9304-0.93133l0.72813-5.1308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.17 58.304 0.03387 1.5748q1.8457-1.8119 3.7592-1.8119 1.0837 0 1.6933 0.62653 0.6096 0.62653 0.44027 1.778l-0.88053 6.2484h-3.0819l0.74506-5.2832q0.06773-0.47413-0.0508-0.62653-0.1016-0.16933-0.4572-0.13547-0.79586 0.01693-1.9981 0.9652l-0.7112 5.08h-3.0819l1.1684-8.4158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.483 58.304 0.03387 1.5748q1.8457-1.8119 3.7592-1.8119 1.0837 0 1.6933 0.62653t0.44027 1.778l-0.88053 6.2484h-3.0819l0.74507-5.2832q0.06773-0.47413-0.0508-0.62653-0.1016-0.16933-0.4572-0.13547-0.79586 0.01693-1.9981 0.9652l-0.7112 5.08h-3.0819l1.1684-8.4158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.401 64.332 0.2032 1.9135q-1.5071 0.67733-3.8608 0.67733-2.6077 0-3.556-1.1007-0.94826-1.1176-0.69426-3.4205 0.28787-2.5231 1.4393-3.4205 1.1684-0.9144 3.5729-0.9144 2.3876 0 3.2681 0.762 0.88053 0.74506 0.6604 2.2691-0.16933 1.1345-0.98213 1.6087-0.79586 0.4572-2.54 0.59266l-2.286 0.16933q0.01693 0.64347 0.33867 0.8636 0.32173 0.2032 1.0837 0.2032 1.6087 0 3.3528-0.2032zm-4.5889-2.4892 1.4224-0.13547q0.62653-0.0508 0.89746-0.22013 0.28787-0.18627 0.33867-0.69426 0.03387-0.4064-0.16933-0.52493-0.2032-0.13547-0.84666-0.11853-0.77893 0.01693-1.1176 0.3556-0.32173 0.32173-0.52493 1.3377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.63 58.067-0.6604 2.8279h-0.7112q-0.8128 0-2.4892 0.59266l-0.7112 5.2324h-3.0988l1.1853-8.4158h2.4045l0.0508 1.3377q1.7949-1.5748 3.4544-1.5748z"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 132.3936,
    y: 77.035606,
    fontFamily: "Monstroula",
    fontSize: "16.933px",
    letterSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 132.3936,
    y: 77.035606,
    fontFamily: "exo2",
    fontSize: "16.933px",
    strokeWidth: 0.26458
  }, "Runner")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.593225096f087e81df448f4e421f906a.svg";
export { ForwardRef as ReactComponent };